export default [
    {
        path: 'jornada',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-jornada' */
            '@/views/exame-laboratorial/jornada/Index'
        ),
        redirect: 'jornada/index',
        children: [
            {
                name: 'exame-laboratorial-jornada-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-jornada' */
                    '@/views/exame-laboratorial/jornada/List.vue'
                ),
            },
            {
                name: 'exame-laboratorial-jornada-create',
                path: 'create/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-jornada' */
                    '@/views/exame-laboratorial/jornada/Form.vue'
                ),
            },
        ],
    },
]